<template>
  <OurPage :title="$t('title.survey._')">
    <SurveyList
      :items="surveyListData"
      :headers="surveyListHeaders"
      :pagination-data="paginationData"
      :is-loading="isLoading"
      @pageChange="getData"
      @onClickRow="onClickRow"
    />
    <template #header-right>
      <div class="buttons">
        <TableColumnsSettings
          v-if="!isMobileDevice && isTableColumnsReady"
          :headers="tableHeaders"
          :table-key="tablePreferenceKey"
          data-cy="survey-list-columns"
        />

        <OurLink v-if="getPermission['survey.create']" :route="addRoute">
          <OurButton :text="$t('button.add')" />
        </OurLink>
      </div>
    </template>
  </OurPage>
</template>

<script>
import SurveyList from "@/views/settings/survey/index/_components/SurveyList.vue";
import { surveyListQuery } from "@/views/settings/survey/index/gql/queries";
import tableColumnsMixin from "@/mixins/tableColumns.mixin";
import TableColumnsSettings from "@/components/TableColumnsSettings.vue";
import { buildSurveyListTableHeaders } from "@/views/settings/survey/index/config/surveyListTableHeaders";
import DateService from "@/services/date.service";
import apolloMixin from "@/mixins/apollo.mixin";
import { mapGetters } from "vuex";

export default {
  name: "SurveyIndex",
  components: { SurveyList, TableColumnsSettings },
  mixins: [apolloMixin, tableColumnsMixin],
  data() {
    return {
      surveyListData: [],
      paginationData: {},
      sorting: {
        column: "createdAt",
        direction: "desc",
      },
      isLoading: false,
      tableColumnsId: "survey-list",
    };
  },
  computed: {
    ...mapGetters("breakpoint", ["isMobileDevice"]),
    ...mapGetters("user", ["getPermission"]),

    addRoute() {
      return { name: "SurveyAdd" };
    },

    tableHeaders() {
      return buildSurveyListTableHeaders({
        t: (key) => this.$t(key),
      });
    },

    surveyListHeaders() {
      if (!this.isTableColumnsReady) {
        return null;
      }

      return this.visibleTableHeaders;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData(page = parseInt(this.$route.query.page) ?? 1) {
      this.isLoading = true;

      try {
        const { surveyList } = await this.$get(surveyListQuery, {
          page,
          orderBy: this.sorting,
        });

        if (surveyList) {
          this.surveyListData = surveyList.data.map((item) => ({
            id: item.id,
            title: item.title,
            validityPeriod: this.formatValidityPeriod(item.startsAt, item.endsAt),
            maxShows: item.maxShows,
            page: "SurveyEdit",
            viewedDealersCount: item.viewedDealersCount,
          }));
          this.paginationData = surveyList.paginatorInfo;
        }
      } finally {
        this.isLoading = false;
      }
    },

    formatValidityPeriod(startsAt, endsAt) {
      if (!startsAt || !endsAt) {
        return "–";
      }

      const start = DateService.dateConverter(startsAt);
      const end = DateService.dateConverter(endsAt);

      return `${start} – ${end}`;
    },

    onClickRow(id) {
      this.$router.push({ name: "SurveyEdit", params: { id } });
    },
  },
};
</script>

<style scoped lang="postcss">
.buttons {
  @apply flex items-center gap-4;
}
</style>
